/** Dinheiro sempre em centavos (inteiro). */

/** 4670 -> "R$ 46,70" */
export function formatMoney(cents: number): string {
  const negative = cents < 0;
  const abs = Math.abs(Math.round(cents));
  const reais = Math.floor(abs / 100);
  const centavos = String(abs % 100).padStart(2, '0');
  const withDots = String(reais).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${negative ? '-' : ''}R$ ${withDots},${centavos}`;
}

/** Sem centavos quando são zero: 12000 -> "R$ 120"; 4670 -> "R$ 46,70" (painéis e linhas da agenda). */
export function formatMoneyShort(cents: number): string {
  const full = formatMoney(cents);
  return Math.round(cents) % 100 === 0 ? full.slice(0, -3) : full;
}

/** 4670 -> "46,70" (para campos de texto) */
export function centsToInput(cents: number): string {
  const abs = Math.abs(Math.round(cents));
  return `${cents < 0 ? '-' : ''}${Math.floor(abs / 100)},${String(abs % 100).padStart(2, '0')}`;
}

/** "46,70" | "46.70" | "R$ 1.234,56" | "50" -> centavos. Retorna null se inválido. */
export function parseMoney(input: string | null | undefined): number | null {
  if (input === null || input === undefined) return null;
  let s = input.replace(/R\$|\s/g, '');
  if (s === '') return null;
  const negative = s.startsWith('-');
  if (negative) s = s.slice(1);
  if (!/^[\d.,]+$/.test(s)) return null;
  const lastComma = s.lastIndexOf(',');
  const lastDot = s.lastIndexOf('.');
  let integer: string;
  let fraction = '';
  if (lastComma >= 0 && lastComma > lastDot) {
    integer = s.slice(0, lastComma).replace(/\./g, '');
    fraction = s.slice(lastComma + 1);
  } else if (lastDot >= 0 && s.length - lastDot - 1 <= 2 && lastComma < 0 && (s.match(/\./g) ?? []).length === 1) {
    integer = s.slice(0, lastDot);
    fraction = s.slice(lastDot + 1);
  } else {
    integer = s.replace(/[.,]/g, '');
  }
  if (fraction.length > 2 || !/^\d*$/.test(integer) || !/^\d*$/.test(fraction)) return null;
  const cents = Number(integer || '0') * 100 + Number(fraction.padEnd(2, '0') || '0');
  return negative ? -cents : cents;
}
